import React, { useEffect, useState } from 'react';
import Card from '../../../common/components/Card/Card';
import Input from '../../../common/components/Input/Input';
import CustomSelect from '../../../common/components/CustomSelect/CustomSelect';
import './Contract.scss';
import { EvidencesTable } from '../../../indication/components/IndicationsScreen/IndicationsScreen';
import BenefitsTable from './Bennefits';
import Checkbox from '../../../common/components/Checkbox';
import Button from '../../../common/components/Button';
import { ConfirmationModal } from '../../../common/components/Modal/Modal';
import add_contract from '../../../assets/icons/plus_ic.svg';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { dateStr, getDate } from '../../../utils/date';
import { zeroPad } from '../../../utils/various';
import { connect } from 'react-redux';
import actions from '../../../actions';
import { PAMINotificationsSection } from '../PAMINotificationsSection';
import AdelantoStatusBadge from './AdelantoStatusBadge';
import { getImporteNexCalculado } from '../../../adelanto/adelantoNexAmount';
import { ADELANTO_TRANSACTION_STATUS } from '../../../constants';
import {
    getContratoVersionStartDateMinimum,
    getNewContratoVersionMinimumStartDate,
    getNextContratoVersionNumber,
    getLatestPersistedBusinessVersion,
    resolveAdelantoProductSelection,
} from '../../contractVersion';
import {
    getAdelantoUiStatus,
    getAdelantoUnidadesRegistradas,
    hasAdelantoEnviado,
    findPrimaryAdelantoNex,
} from '../../../adelanto/adelantoNexState';
import {
    formatPreviousVersionQuotaWarning,
    getPendingAdelantoQuotaWarning,
    isPendingAdelantoQuotaConfirmationAccepted,
} from '../../../adelanto/adelantoPreviousVersionWarning';

const addContract = <img src={add_contract} alt='Add contract' />;

const riskSharingCalculationTypes = [
    { value: 'U', label: 'Formula del ultimo ciclo/rango' },
    { value: 'C', label: 'Formula de cada ciclo/rango' },
];
const operatorCalculateBen = [
    { value: 'S', label: 'Suma' },
    { value: 'M', label: 'Multiplicación' },
];

const Version = ({
    version,
    updVersion,
    indication,

    product_families,
    auditorGroups,
    showErrors,
    evidenceTypes,
    isSur,
    isPami,
    isVolume,
    isAdelanto,
    // lastVersion,
    typeContractSelected,
    versionStartDateMinimum,
}) => {
    if (!version) return null;

    const {
        // version: c_version,
        estado_version,

        vigencia_desde,
        fin_incorp_pacientes,
        vigencia_hasta,
        unidades_por_periodo, // for Volume + Adelanto (V2: labelled "Unidades por compra")
        dias_vto_lst_precios, // for Volume
        max_pacientes,
        cant_pacientes_activos,
        estado, // what is this? estado_version?

        // frecuencia_control,
        tolerancia_periodo,
        tolerancia_dosis,

        // tipo_calculo_rc,
        grupo_auditor,
        compartir_nya, //
        compartir_dni, //
        compartir_afiliado, //

        notificaciones,
    } = version ?? {};

    const updVersionAtt = (obj) => updVersion({ ...version, ...obj });

    const updVerAttDate = (obj) => {
        Object.keys(obj).map((key) => {
            obj[key] = obj[key] ? dateStr(obj[key]) : undefined;
        });
        updVersionAtt(obj);
    };

    const addEvidence = () => {
        if (readOnly) return;
        const evidences = version.contrato_v_evidencia ?? [];
        const newEvidence = {
            _id:
                evidences?.reduce((prev, current) => (prev._id > current._id ? prev : current), {
                    _id: 0,
                })._id + 1,
            numero:
                evidences?.reduce(
                    (prev, current) => (prev.numero > current.numero ? prev : current),
                    { numero: 0 },
                ).numero + 1,
        };
        updVersionAtt({ contrato_v_evidencia: [...evidences, newEvidence] });
    };

    // Function que genera un id, del tipo string, random con muy pocas chances de repetirse
    const uniqueIdGenerator = () => ((Math.random() * 100) % 1).toString().slice(2);

    const addBenefits = (b) => {
        const benefits = version.contrato_v_beneficio ?? [];
        if (isAdelanto) {
            const selected = resolveAdelantoProductSelection(product_families, b);
            if (!selected) return;
            const { family, product } = selected;
            updVersionAtt({
                contrato_v_beneficio: [
                    {
                        ...product,
                        _id: uniqueIdGenerator(),
                        producto: product.id,
                        id: undefined,
                        aplicacion_desde: 1,
                        aplicacion_hasta: 1,
                        familia_producto: family.id,
                        groupId: `1-1-${family.id}`,
                    },
                ],
            });
            return;
        }
        // get biggest aplicacion_hasta from benefits
        const bah =
            benefits?.reduce(
                (prev, current) =>
                    prev.aplicacion_hasta > current.aplicacion_hasta ? prev : current,
                { aplicacion_hasta: 0 },
            ).aplicacion_hasta + 1;

        const { aplicacion_hasta } = benefits[benefits?.length - 1] ?? { aplicacion_hasta: 0 };
        const prod = product_families
            ?.find((pf) => pf.id === b)
            ?.products?.map((p) => ({
                ...p,
                _id: uniqueIdGenerator(),
                producto: p.id,
                id: undefined,
                aplicacion_desde: parseInt(aplicacion_hasta) + 1,
                aplicacion_hasta: parseInt(aplicacion_hasta) + 2,
                familia_producto: b,
                groupId: `${bah}-${bah + 1}-${b}`,
            }));
        if (!prod) return;
        updVersionAtt({ contrato_v_beneficio: [...benefits, ...prod] });
    };

    const indicationFams = Array.from(
        new Set(indication?.indicacion_familiaprod?.map((pd) => pd.familia_producto)),
    );

    const selectableFams = product_families?.filter((pf) => indicationFams.includes(pf.id));

    const _estado = estado === 'B' ? 'B' : estado_version;
    const toggleEstado = () => {
        updVersionAtt({ estado: estado === 'B' ? estado_version : 'B' });
    };

    // For volume contracts, we need to check if there are any volume transactions registered
    // This is a more robust check since cant_txns might not be properly updated for volume contracts
    const hasVolumeTransactions = isVolume && version.cant_txns > 0;

    /*
     * FR-NEW-03 — Adelanto NEX readOnly lock.
     *
     * Once an advance has been emitted for a version (any state past
     * NOT_SENT), the version is frozen from edits. Mirrors the existing
     * `cant_txns > 0` lock on Volumen but driven by `adelanto_status`.
     *
     * Backend BA-04 enforces the same rule server-side; this check is the
     * FE counterpart so the form disables the inputs proactively.
     */
    const hasAdelantoEmitted =
        isAdelanto && (version.adelanto_nex_bloqueado || hasAdelantoEnviado(version));

    const adelantoUiStatus = isAdelanto ? getAdelantoUiStatus(version) : null;
    const adelantoUnitsRegistered = isAdelanto ? getAdelantoUnidadesRegistradas(version) : 0;

    const readOnly = hasVolumeTransactions || version.cant_txns > 0 || hasAdelantoEmitted;

    // Debug logging for volume contracts
    console.log('🔍 Version Debug:', {
        isVolume,
        isAdelanto,
        version_id: version.id,
        cant_txns: version.cant_txns,
        adelanto_status: adelantoUiStatus,
        hasVolumeTransactions,
        hasAdelantoEmitted,
        readOnly,
        version,
    });

    const minimumStartDate = versionStartDateMinimum
        ? moment(versionStartDateMinimum, 'YYYY-MM-DD', true).toDate()
        : undefined;

    return (
        <div className='body-version'>
            <div className='bv-dp dl-mwmc'>
                <div>
                    <label
                        className={
                            'input-label ' +
                            (showErrors && (vigencia_desde ? '' : 'error-next-datepicker'))
                        }
                    >
                        {I18n.t(
                            'contract.versionDetail.dateRangePicker.startDatePickerPlaceholder',
                        )}
                    </label>
                    <DatePicker
                        disabled={readOnly}
                        selected={vigencia_desde ? getDate(vigencia_desde) : undefined}
                        dateFormat='dd/MM/yyyy'
                        minDate={minimumStartDate}
                        maxDate={
                            fin_incorp_pacientes || vigencia_hasta
                                ? Math.min(...[getDate(fin_incorp_pacientes)].filter((d) => d))
                                : undefined
                        }
                        onChange={(v) => {
                            updVerAttDate({
                                vigencia_desde: v,
                            });
                        }}
                        placeholderText={moment().format('DD/MM/YYYY')}
                        autoComplete='on'
                    />
                </div>
                {!isVolume && !isAdelanto && (
                    <>
                        <div>
                            <label
                                className={
                                    'input-label ' +
                                    (showErrors &&
                                        (fin_incorp_pacientes ? '' : 'error-next-datepicker'))
                                }
                            >
                                {I18n.t(
                                    'contract.versionDetail.dateRangePicker.endPatientDischargePlaceholder',
                                )}
                            </label>
                            <DatePicker
                                disabled={readOnly}
                                selected={
                                    fin_incorp_pacientes ? getDate(fin_incorp_pacientes) : undefined
                                }
                                dateFormat='dd/MM/yyyy'
                                minDate={getDate(vigencia_desde)}
                                maxDate={getDate(vigencia_hasta)}
                                onChange={(v) =>
                                    updVerAttDate({
                                        fin_incorp_pacientes: v,
                                    })
                                }
                                placeholderText={moment(
                                    getDate(vigencia_desde) || new Date(),
                                ).format('DD/MM/YYYY')}
                                autoComplete='off'
                            ></DatePicker>
                        </div>
                    </>
                )}
                <div>
                    <label
                        className={
                            'input-label ' +
                            (showErrors && (vigencia_hasta ? '' : 'error-next-datepicker'))
                        }
                    >
                        {I18n.t(
                            'contract.versionDetail.dateRangePicker.endRegistrationPlaceholder',
                        )}
                    </label>
                    <DatePicker
                        disabled={readOnly}
                        selected={getDate(vigencia_hasta)}
                        dateFormat='dd/MM/yyyy'
                        minDate={
                            isVolume || isAdelanto
                                ? getDate(vigencia_desde)
                                : getDate(fin_incorp_pacientes)
                        }
                        onChange={(v) => updVerAttDate({ vigencia_hasta: v })}
                        // onChangeRaw={handleDateChangeRaw}
                        placeholderText={moment(getDate(vigencia_desde) || new Date()).format(
                            'DD/MM/YYYY',
                        )}
                        autoComplete='off'
                    />
                </div>
                {isVolume && (
                    <>
                        <div className=''>
                            <Input
                                disabled={readOnly}
                                className='white ip-custom-mx'
                                value={unidades_por_periodo}
                                type='number'
                                handleChange={(v) => updVersionAtt({ unidades_por_periodo: v })}
                                label={I18n.t(
                                    'contract.versionDetail.inputLabels.unitsPerInterval',
                                )}
                                error={showErrors && !(unidades_por_periodo > 0)}
                            />
                        </div>
                        <div className=''>
                            <Input
                                disabled={readOnly}
                                className='white ip-custom-mx'
                                value={dias_vto_lst_precios}
                                type='number'
                                handleChange={(v) => updVersionAtt({ dias_vto_lst_precios: v })}
                                label={I18n.t(
                                    'contract.versionDetail.inputLabels.priceListDaysToVoid',
                                )}
                                error={showErrors && !(unidades_por_periodo > 0)}
                            />
                        </div>
                    </>
                )}
                {isAdelanto && (
                    <>
                        <div className=''>
                            <Input
                                disabled={readOnly}
                                className='white ip-custom-mx'
                                value={unidades_por_periodo}
                                type='number'
                                handleChange={(v) => updVersionAtt({ unidades_por_periodo: v })}
                                label={I18n.t(
                                    'contract.versionDetail.inputLabels.unitsPerPurchase',
                                )}
                                error={showErrors && !(unidades_por_periodo > 0)}
                            />
                        </div>
                        {/* Adelanto NEX — running count of units registered against
                            the current version's cupo. System-managed (derived
                            from on-chain consumption / OS registration flow), so
                            it's always disabled in the UI. Defaults to 0 so the
                            field shows a value as soon as the user enters edit
                            mode, even for fresh contracts where nothing has been
                            registered yet. */}
                        <div className=''>
                            <Input
                                disabled
                                className='white ip-custom-mx'
                                value={adelantoUnitsRegistered}
                                type='number'
                                label={I18n.t('contract.versionDetail.inputLabels.unitsRegistered')}
                            />
                        </div>
                    </>
                )}
                {!isVolume && !isAdelanto && (
                    <>
                        <div className=''>
                            <Input
                                disabled={readOnly}
                                className='white ip-custom-mx'
                                value={max_pacientes}
                                type='number'
                                handleChange={(v) => updVersionAtt({ max_pacientes: v })}
                                label={I18n.t('contract.versionDetail.inputLabels.patientsMax')}
                                error={showErrors && !(max_pacientes > 0)}
                            />
                        </div>
                        <div className=''>
                            <Input
                                disabled
                                className='white ip-custom-mx'
                                value={cant_pacientes_activos}
                                type='number'
                                label={I18n.t('contract.versionDetail.inputLabels.activePatients')}
                                error={showErrors && cant_pacientes_activos < 0}
                            />
                        </div>
                    </>
                )}
                <div className='vl' />
                <div className='bv-status'>
                    <div className='label-status'>
                        {I18n.t('contract.versionDetail.inputLabels.status')}
                    </div>
                    <div className={'bv-btn-status status-' + _estado} onClick={toggleEstado}>
                        {I18n.t('contract.versionDetail.status.' + _estado ?? 'B')}
                    </div>
                </div>
            </div>
            <hr />
            <div className='bv-dp bv-dp-even'>
                <div className='vl'></div>
                {!isSur && !isVolume && !isAdelanto && (
                    <>
                        <div className='bv-display'>
                            <Input
                                disabled={readOnly}
                                className='white ip-custom'
                                value={tolerancia_periodo}
                                type='number'
                                handleChange={(v) => updVersionAtt({ tolerancia_periodo: v })}
                                label={
                                    <>
                                        <div>
                                            {I18n.t(
                                                'contract.versionDetail.inputLabels.controlPeriodTolerance1',
                                            )}
                                            <br />
                                            {I18n.t(
                                                'contract.versionDetail.inputLabels.controlPeriodTolerance2',
                                            )}
                                        </div>
                                        <br />
                                        <div className='sub-label'>
                                            {I18n.t(
                                                'contract.versionDetail.inputLabels.controlPeriodTolerance3',
                                            )}
                                        </div>
                                    </>
                                }
                            />
                        </div>
                        <div className='vl'></div>
                        <div className='bv-display'>
                            <Input
                                disabled={readOnly}
                                className='white ip-custom'
                                value={tolerancia_dosis}
                                type='number'
                                handleChange={(v) => updVersionAtt({ tolerancia_dosis: v })}
                                label={
                                    <>
                                        <div>
                                            {I18n.t(
                                                'contract.versionDetail.inputLabels.doseToleranceMg1',
                                            )}
                                            <br />
                                            {I18n.t(
                                                'contract.versionDetail.inputLabels.doseToleranceMg2',
                                            )}
                                        </div>
                                        <br />
                                        <div className='sub-label'>
                                            {I18n.t(
                                                'contract.versionDetail.inputLabels.doseToleranceMg3',
                                            )}
                                        </div>
                                    </>
                                }
                                // error={showErrors && (tolerancia_dosis == null || tolerancia_dosis > 100)}
                            />
                        </div>
                    </>
                )}
            </div>
            <br />
            {!isSur && !isVolume && !isAdelanto && (
                <Card
                    classHead='card-head-mod'
                    title={I18n.t('contract.versionDetail.audit.title')}
                >
                    <div className='card-row'>
                        <div className='cb-mt'>
                            <div key='input-label'>
                                <label className='input-label'>
                                    {I18n.t('contract.versionDetail.audit.group')}
                                </label>
                            </div>
                            <CustomSelect
                                disabled={readOnly}
                                options={
                                    auditorGroups
                                        ?.map((ag) => ({ value: ag.id, label: ag.razon_social }))
                                        ?.sort((a, b) =>
                                            a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1,
                                        ) ?? []
                                }
                                value={grupo_auditor}
                                onSelect={(v) => updVersionAtt({ grupo_auditor: v })}
                                placeholder=''
                            />
                        </div>
                        <hr />
                        <div className='cb-mt'>
                            <label className='input-label il-label-aud'>
                                {I18n.t('contract.versionDetail.audit.shareinfo')}
                            </label>
                            <div className='il-chb'>
                                <Checkbox
                                    id='nameSurname'
                                    disabled={readOnly}
                                    label={I18n.t(
                                        'contract.versionDetail.audit.selectedFilter.nameSurname',
                                    )}
                                    checked={compartir_nya}
                                    onChange={() =>
                                        updVersionAtt({ compartir_nya: !compartir_nya })
                                    }
                                />
                                <Checkbox
                                    id='dni'
                                    label={I18n.t(
                                        'contract.versionDetail.audit.selectedFilter.dni',
                                    )}
                                    checked={compartir_dni}
                                    disabled={readOnly}
                                    onChange={() =>
                                        updVersionAtt({ compartir_dni: !compartir_dni })
                                    }
                                />
                                <Checkbox
                                    id='afiliateNumber'
                                    label={I18n.t(
                                        'contract.versionDetail.audit.selectedFilter.afiliateNumber',
                                    )}
                                    checked={compartir_afiliado}
                                    disabled={readOnly}
                                    onChange={() =>
                                        updVersionAtt({ compartir_afiliado: !compartir_afiliado })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </Card>
            )}
            {isPami && (
                <PAMINotificationsSection
                    notificaciones={
                        version?.notificaciones ?? {
                            dias_antes_registracion_1: null,
                            dias_antes_registracion_2: null,
                            dias_antes_evidencia_1: null,
                            dias_antes_evidencia_2: null,
                        }
                    }
                    onInputChange={(notificaciones) =>
                        updVersion({
                            ...version,
                            notificaciones,
                        })
                    }
                />
            )}
            <Card
                className='card-custom'
                classHead='card-head-mod'
                classBody='card-body-custom'
                title={I18n.t('contract.versionDetail.benefitCard.title')}
            ></Card>
            <BenefitsTable
                indication={indication}
                benefits={version.contrato_v_beneficio}
                setBenefits={(v) => updVersionAtt({ contrato_v_beneficio: v })}
                product_families={product_families}
                operatorCalculateBen={operatorCalculateBen}
                isSur={isSur}
                isVolume={isVolume}
                isAdelanto={isAdelanto}
                readOnly={readOnly}
                typeContractSelected={typeContractSelected}
            />
            <br />

            <div className='add-app'>
                <CustomSelect
                    options={
                        isAdelanto
                            ? product_families?.flatMap((pf) =>
                                  (pf.products ?? []).map((product) => ({
                                      value: product.id,
                                      label: `${pf.denominacion} | ${product.denominacion}`,
                                  })),
                              ) ?? []
                            : isSur || isVolume
                            ? product_families?.map((pf) => ({
                                  value: pf.id,
                                  label: pf.denominacion,
                              })) ?? []
                            : selectableFams?.map((pf) => ({
                                  value: pf.id,
                                  label: pf.denominacion,
                              })) ?? []
                    }
                    value={undefined}
                    onSelect={(v) => addBenefits(v)}
                    placeholder=''
                    overwrite={true}
                    disabled={readOnly}
                    className='rounded i-screen csoc_mw mxh coptop'
                    searchable={true}
                >
                    {I18n.t('contract.versionDetail.benefitCard.addApplication')}
                </CustomSelect>
            </div>

            {typeContractSelected === 3 && (
                <>
                    <hr className='hr-add-pp' />

                    <div className='card-row'>
                        <div className='cb-mt'>
                            <div key='input-label'>
                                <label className='input-label'>
                                    {I18n.t(
                                        'contract.versionDetail.benefitCard.riskSharingCalculation',
                                    )}
                                </label>
                            </div>
                            <CustomSelect
                                options={riskSharingCalculationTypes.map((type) => ({
                                    value: type?.value,
                                    label: type?.label,
                                }))}
                                value={
                                    version.tipo_calculo_rc ??
                                    riskSharingCalculationTypes.filter(
                                        (type) => type.value === 'U',
                                    )[0].value
                                }
                                onSelect={(v) => {
                                    updVersionAtt({ tipo_calculo_rc: v });
                                }}
                                className='rounded i-screen mxh'
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                </>
            )}

            <br />
            <br />
            <hr />
            {!isSur && !isVolume && !isAdelanto && evidenceTypes?.length > 0 && (
                <Card title='Evidencias'>
                    <br />
                    <EvidencesTable
                        evidences={version.contrato_v_evidencia}
                        setEvidences={(v) => {
                            updVersionAtt({
                                contrato_v_evidencia: v.map((e) => ({
                                    ...e,
                                    dias: e.dias || null,
                                })),
                            });
                        }}
                        isPami={isPami}
                        showErrors={showErrors}
                        evidenceTypes={evidenceTypes}
                        readOnly={readOnly}
                    />
                    <br />
                    <div className='card-rlink' onClick={!readOnly ? addEvidence : ''}>
                        {I18n.t('indication.details.evidences.addNew')}
                    </div>
                    <br />
                </Card>
            )}
        </div>
    );
};

const VersionContainer = ({
    versions,
    updVersions,
    indication,

    selectedIndication,
    getIndications,

    product_families,
    auditorGroups,
    showErrors,
    getProdFamily,
    evidenceTypes,
    isSur,
    isVolume,
    isPami,
    isAdelanto,
    getEvidenceType,
    lastVersion,
    typeContractSelected,
    showAdelantoSendBadge = false,
    currentVersion = 0,
    onCurrentVersionChange,
}) => {
    const [showPendingQuotaConfirmation, setShowPendingQuotaConfirmation] = useState(false);
    const [quotaConfirmationText, setQuotaConfirmationText] = useState('');
    const [pendingQuotaWarning, setPendingQuotaWarning] = useState(null);

    useEffect(() => {
        if (indication != undefined) getIndications(indication);
    }, [indication]);

    useEffect(() => {
        getProdFamily(true);
        getEvidenceType();
    }, []);

    const setCurrentVersion = (idx) => {
        if (onCurrentVersionChange) {
            onCurrentVersionChange(idx);
        }
    };

    const version = versions?.[currentVersion];
    const adelantoUiStatus = isAdelanto && version ? getAdelantoUiStatus(version) : null;
    const hasUnsavedVersion = versions?.some((v) => !v?.id);
    const newVersionMinimumStartDate = getNewContratoVersionMinimumStartDate(versions);
    const nextBusinessVersionNumber = getNextContratoVersionNumber(versions);
    const versionStartDateMinimum = getContratoVersionStartDateMinimum(version, versions);
    const updVersion = (v) => {
        let _ver = versions?.map((_v, i) => (i === currentVersion ? v : _v));
        updVersions(_ver);
    };

    const commitAddVersion = () => {
        if (hasUnsavedVersion) {
            return;
        }
        if (
            (!selectedIndication?.indicacion_evidencia || !indication) &&
            !isSur &&
            !isVolume &&
            !isAdelanto
        ) {
            alert('Seleccione una indicacion');
            return;
        }

        const _id =
            versions?.reduce((prev, current) => (prev._id > current._id ? prev : current), {
                _id: 0,
            })._id + 1;
        const mut_version = version
            ? {
                  ...version,
                  id: undefined,
                  contrato_v_beneficio:
                      version?.contrato_v_beneficio?.map((b) => ({ ...b, id: undefined })) ?? [],
                  contrato_v_evidencia:
                      version?.contrato_v_evidencia?.map((e) => ({ ...e, id: undefined })) ?? [],
              }
            : {};
        const defaultData = {
            compartir_afiliado: true,
            compartir_dni: true,
            compartir_nya: true,
            estado: 'A',
            estado_version: 'A',
            cant_txns: 0,
            vigencia_desde: newVersionMinimumStartDate,
            vigencia_hasta: '',
            fin_incorp_pacientes: '',
        };
        const adelantoNewVersionFields = isAdelanto
            ? {
                  adelantos_nex: [],
                  adelanto_status: ADELANTO_TRANSACTION_STATUS.NOT_SENT,
                  adelanto_nex_bloqueado: false,
                  unidades_registradas: 0,
                  importe_nex_calculado: null,
                  adelanto_nex_preparado: null,
                  advertencia_cupo_adelanto_anterior: null,
              }
            : {};

        updVersions([
            ...versions,
            {
                contrato_v_beneficio: undefined,
                ...mut_version,
                id: undefined,
                contrato_v_evidencia:
                    selectedIndication?.indicacion_evidencia?.map((ev) => ({
                        ...ev,
                        _id: ev.id,
                        id: undefined,
                    })) ?? [],
                _id,
                ...defaultData,
                ...adelantoNewVersionFields,
                version: nextBusinessVersionNumber,
            },
        ]);
        setCurrentVersion(versions?.length);
    };

    const closePendingQuotaConfirmation = () => {
        setShowPendingQuotaConfirmation(false);
        setQuotaConfirmationText('');
        setPendingQuotaWarning(null);
    };

    const addVersion = () => {
        if (hasUnsavedVersion) return;

        const latestPersistedVersion = getLatestPersistedBusinessVersion(versions);
        const quotaWarning = isAdelanto
            ? getPendingAdelantoQuotaWarning(latestPersistedVersion)
            : null;

        if (quotaWarning) {
            setPendingQuotaWarning(quotaWarning);
            setQuotaConfirmationText('');
            setShowPendingQuotaConfirmation(true);
            return;
        }

        commitAddVersion();
    };

    const confirmPendingQuotaAndAddVersion = () => {
        if (!isPendingAdelantoQuotaConfirmationAccepted(quotaConfirmationText)) return;
        closePendingQuotaConfirmation();
        commitAddVersion();
    };

    const version_options =
        versions?.map((ver, i) => ({
            value: i,
            label: `${i} - ${ver.vigencia_desde} - ${I18n.t(
                'contract.versionDetail.status.' + ver.estado ?? 'B',
            )}`,
        })) ?? [];

    return (
        <div className='section-detail-contract'>
            <div className='header-version'>
                <div>
                    <CustomSelect
                        options={version_options}
                        value={currentVersion}
                        onSelect={(v) => setCurrentVersion(v)}
                        placeholder=''
                        overwrite={true}
                        className='csoc_mw'
                    >
                        {I18n.t('contract.versionDetail.title')}
                        <i className='icon-arrow-down hv-padd' />
                    </CustomSelect>
                </div>
                <div className='hv-nr-btn hv-padd'>
                    <div>
                        {/* FR-05 — read-only Adelanto NEX status pill (left of
                            version-picker arrows). Adelanto NEX only. */}
                        {isAdelanto && showAdelantoSendBadge && (
                            <AdelantoStatusBadge
                                status={adelantoUiStatus}
                                nexAmount={
                                    findPrimaryAdelantoNex(version)?.importe_nex ??
                                    getImporteNexCalculado(version)
                                }
                            />
                        )}
                        <i
                            className='icon-arrow-left hv-padd'
                            onClick={() => {
                                if (currentVersion <= 0) return;
                                setCurrentVersion(currentVersion - 1);
                            }}
                        />
                        {zeroPad(currentVersion + 1, 3)}
                        <i
                            className='icon-arrow-right hv-padd'
                            onClick={() => {
                                if (currentVersion >= versions?.length - 1) return;
                                setCurrentVersion(currentVersion + 1);
                            }}
                        />
                    </div>
                    <Button
                        type='button'
                        className='primary sm'
                        onClick={addVersion}
                        text={addContract}
                        disabled={hasUnsavedVersion}
                    />
                </div>
            </div>
            <Version
                version={version}
                updVersion={updVersion}
                indication={selectedIndication}
                product_families={product_families}
                auditorGroups={auditorGroups}
                showErrors={showErrors}
                evidenceTypes={evidenceTypes}
                isSur={isSur}
                isVolume={isVolume}
                isPami={isPami}
                isAdelanto={isAdelanto}
                typeContractSelected={typeContractSelected}
                versionStartDateMinimum={versionStartDateMinimum}
            />
            <ConfirmationModal
                show={showPendingQuotaConfirmation}
                title={I18n.t('contract.adelantoNex.warnings.previousVersionPendingConfirmTitle')}
                submit={confirmPendingQuotaAndAddVersion}
                cancel={closePendingQuotaConfirmation}
                close={closePendingQuotaConfirmation}
                submitText={I18n.t(
                    'contract.adelantoNex.warnings.previousVersionPendingConfirmSubmit',
                )}
                disableSubmitButton={
                    !isPendingAdelantoQuotaConfirmationAccepted(quotaConfirmationText)
                }
            >
                <div onClick={(event) => event.stopPropagation()}>
                    <p>{formatPreviousVersionQuotaWarning(pendingQuotaWarning)}</p>
                    <p>{I18n.t('contract.adelantoNex.warnings.previousVersionPendingConfirm')}</p>
                    <Input
                        value={quotaConfirmationText}
                        handleChange={setQuotaConfirmationText}
                        label={I18n.t(
                            'contract.adelantoNex.warnings.previousVersionPendingConfirmInput',
                        )}
                    />
                </div>
            </ConfirmationModal>
        </div>
    );
};

const mapStateToProps = (state) => ({
    product_families: state.indication.product_families,
    evidenceTypes: state.indication.evidenceTypes,
});

const mapDispatchToProps = (dispatch) => ({
    getProdFamily: (getProducts) => dispatch(actions.indication.getProdFamily(getProducts)),
    getEvidenceType: () => dispatch(actions.indication.getEvidenceType()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VersionContainer);
